import { render, staticRenderFns } from "./DetailKTRevenueDialog.vue?vue&type=template&id=36ceb5c9&scoped=true"
import script from "./DetailKTRevenueDialog.vue?vue&type=script&lang=js"
export * from "./DetailKTRevenueDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailKTRevenueDialog.vue?vue&type=style&index=0&id=36ceb5c9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ceb5c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ceb5c9')) {
      api.createRecord('36ceb5c9', component.options)
    } else {
      api.reload('36ceb5c9', component.options)
    }
    module.hot.accept("./DetailKTRevenueDialog.vue?vue&type=template&id=36ceb5c9&scoped=true", function () {
      api.rerender('36ceb5c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/dialog/DetailKTRevenueDialog.vue"
export default component.exports